require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./photos-professional-v-vm-c-3.json") })
        }
      }, "path---photos-professional-v-vm-c-3");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---photos-professional-v-vm-c-3!./.cache/json/photos-professional-v-vm-c-3.json
// module id = 929
// module chunks = 231608221292675